import { DateUtils } from '@flipto/shared/src/lib/utils/common/time/date-utils';

export const getRangeDate = (startDate: Date, range: number): Date => {
    return range === 1 ? startDate : DateUtils.add(startDate, range - 1, 'day').toDate();
};

export const isRangeDateIncludes = (ranges: number[], startDate: Date, date: Date): boolean => {
    return ranges?.map(r => getRangeDate(startDate, r)).some(rangeDate => DateUtils.isSame(rangeDate, date, 'day'));
};
